import React from 'react';
import styles from './FeatureList.module.css';
import { FeatureCard } from '../FeatureCard';
import { FEATURES } from '../../data/features';

export function FeatureList() {
  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>Наши возможности</h2>
      <div className={styles.list}>
        {FEATURES.map((feature, i) => (
          <FeatureCard key={feature.title} feature={feature} index={i} />
        ))}
      </div>
    </section>
  );
}
